/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { Button, Checkbox, Slider } from 'antd'
import {
  calculateAnnualDeductibleRange,
  calculateMonthlyPriceRange
} from 'utils/planUtils'
import $t from '../../../../i18n'

import './PlansFilterDialog.css'
import Dialog from 'components/common/Dialog'

const PlansFilterDialog = ({
  plans,
  onChange,
  selectedTab,
  onApply,
  isFilterOpen,
  onCancel
}) => {
  const [monthlyPremiumRange, setMonthlyPremiumRange] = useState({})
  const [annualDeductibleRange, setAnnualDeductibleRange] = useState({})
  const [selectedFilters, setSelectedFilters] = useState({})

  const planCategory = [
    { label: $t('enroll.plans.filter.bronze'), value: 'bronze' },
    { label: $t('enroll.plans.filter.silver'), value: 'silver' },
    { label: $t('enroll.plans.filter.gold'), value: 'gold' }
  ]

  const coverageCategory = [
    { label: $t('enroll.plans.filter.dental'), value: 'dental' },
    { label: $t('enroll.plans.filter.0copay'), value: '$0 Top Rx' }
  ]

  useEffect(() => {
    const monthlyRange = calculateMonthlyPriceRange(plans)
    const annualRange = calculateAnnualDeductibleRange(plans)
    setMonthlyPremiumRange(monthlyRange)
    setAnnualDeductibleRange(annualRange)
    setSelectedFilters({
      monthlyPremium: monthlyRange?.maxPrice,
      annualDeductible: annualRange?.maxPrice
    })
  }, [])

  // everytime the selected tab changes, reset the filters
  useEffect(() => {
    resetFilters()
  }, [selectedTab])

  const resetFilters = shouldSendChange => {
    const monthlyRange = calculateMonthlyPriceRange(plans)
    const annualRange = calculateAnnualDeductibleRange(plans)
    const resetFilters = {
      monthlyPremium: monthlyRange?.maxPrice,
      annualDeductible: annualRange?.maxPrice
    }
    setSelectedFilters(resetFilters)

    // if on change should be called, call it
    if (shouldSendChange) {
      onChange(resetFilters)
    }
  }

  const onFilterChange = (field, value) => {
    const newFilters = { ...selectedFilters, [field]: value }
    setSelectedFilters(newFilters)
  }

  const onResetFilters = () => {
    resetFilters(true)
  }

  const onFilterApply = () => {
    onChange(selectedFilters)
    onApply()
  }

  const onClose = () => {
    onCancel()
    resetFilters()
  }

  return (
    <Dialog
      title={$t('enroll.plans.filter.title')}
      isVisible={isFilterOpen}
      footerActions={[]}
      onCancel={onClose}
      className='filter-plans-dialog'
      afterOpenChange={isOpen =>
        // scrolling fixed on mobile
        // prevent from body to scroll when dialog is open
        isOpen
          ? (document.body.style.position = 'fixed')
          : (document.body.style.position = 'default')
      }
    >
      <div className='plans-filter'>
        <div className='filter-category'>
          <div className='filter-title'>
            {$t('enroll.plans.filter.monthlyPremium')}
          </div>
          <Slider
            value={selectedFilters?.monthlyPremium}
            min={monthlyPremiumRange?.minPrice}
            max={monthlyPremiumRange?.maxPrice}
            onChange={value => onFilterChange('monthlyPremium', value)}
            tooltip={{
              open: true,
              placement: 'top',
              getPopupContainer: triggerNode => triggerNode.parentNode
            }}
          />
          <div className='filter-title'>
            {$t('enroll.plans.filter.annualDeductible')}
          </div>
          <Slider
            value={selectedFilters?.annualDeductible}
            min={annualDeductibleRange?.minPrice}
            max={annualDeductibleRange?.maxPrice}
            onChange={value => onFilterChange('annualDeductible', value)}
            tooltip={{
              open: true,
              placement: 'top',
              getPopupContainer: triggerNode => triggerNode.parentNode
            }}
          />
        </div>
        <div className='filter-category'>
          <div className='filter-title'>
            {$t('enroll.plans.filter.planCategory')}
          </div>
          <Checkbox.Group
            className='checkbox-filter'
            value={selectedFilters?.planCategory}
            onChange={value => onFilterChange('planCategory', value)}
            options={planCategory}
          />
        </div>
        <div className='filter-category'>
          <div className='filter-title'>
            {$t('enroll.plans.filter.coverage')}
          </div>
          <Checkbox.Group
            className='checkbox-filter'
            value={selectedFilters?.coverageCategory}
            onChange={value => onFilterChange('coverageCategory', value)}
            options={coverageCategory}
          />
        </div>
        <div className='filter-footer'>
          <Button
            className='filter-reset-btn filter-action-btn'
            onClick={onResetFilters}
            type='link'
          >
            {$t('enroll.plans.filter.reset')}
          </Button>
          <Button
            className='filter-apply-btn filter-action-btn'
            onClick={onFilterApply}
            type='primary'
          >
            {$t('enroll.plans.filter.apply')}
          </Button>
        </div>
      </div>
    </Dialog>
  )
}

export default PlansFilterDialog
